//Assign the resources according to the task priorities
function assignAllResources(priorityTasks, simulator) {

    allowMultitasking = simulator.automationMethod == "STAM";
    allowMultitasking = false;
    //For each group, assign tasks according to their main resource.
    assignTasks(priorityTasks, simulator, false, allowMultitasking)
    //Afterwards assign tasks according to their possible alternate resource.
    assignTasks(priorityTasks, simulator, true, allowMultitasking)
}

//Handles an event where an assignmnet is made
function handleEvent(event, simulator) {
    if (event.type == "assignTask") {
        return handleAssignEvent(event, simulator);
    }

    var resourceGroup = simulator.resourcePool.getResourceGroupFromName(event.groupName);
    if (event.type == "startHire" || event.type == "cancelFire") resourceGroup.hireResource();
    else if (event.type == "startFire" || event.type == "cancelHire") resourceGroup.fireResource();
    else if (event.type == "startTrain") resourceGroup.trainResource(event.alternateGroupName);

}

function handleAssignEvent(event, simulator) {
    var resourceGroup = simulator.resourcePool.getResourceGroupFromName(event.groupName);
    var resource = resourceGroup.resourcesDict[event.resourceName];

    //A resource shouldn't have a task, otherwise the assignment is invalid (algorithms can't schedule multitasking)
    if (resource.currentTask != null) {
        console.error("Error");
    }

    //The order should not be able to change
    var project = simulator.projectPool.projects[event.projectIndex];
    if (project.projectIndex != event.projectIndex) {
        console.error("The projects are not in the same order anymore");
    }

    var task = project.taskDict[event.taskID];
    resource.setCurrentTask(task);
}

//Actually assign the tasks to the resources in order
function assignTasks(priorityTasks, simulator, allowOtherTask, allowMultitasking) {
    const resourceGroups = simulator.resourcePool.resourceGroups;
    resourceGroups.forEach(currResourceGroup => {

        currResourceGroup.resources.forEach(currResource => {
            if (!currResource.isActive) {
                return;
            }

            priorityTasks.forEach(currTask => {
                //console.log(currResource, currTask)
                if (isAssignPossible(currResource, currTask, allowOtherTask, allowMultitasking)) {
                    if(allowMultitasking && currResource.currentTask != null){
                        if(priorityTasks.indexOf(currTask) < priorityTasks.indexOf(currResource.currentTask)  && currTask.getRemainingWorkHours() < currResource.currentTask.getRemainingWorkHours()){
                            currResource.setCurrentTask(currTask);
                        }
                    }
                    else{
                        currResource.setCurrentTask(currTask);
                    }
                }
            })
        })
    });
}

//Checks if an assignment is allowed (checks the groups etc)
function isAssignAllowed(task, currResource, allowOtherTask) {
    //If you only want to allow the main resource type of a resource
    if (task.resourceGroupID == "G") {
        return;
    }

    //Checks the main workgroup of a resource
    taskResourceGroupName = currResource.simulator.resourcePool.getResourceGroupFromID(task.resourceGroupID).name;
    if (!allowOtherTask) {
        return currResource.resourceTypes[0] == taskResourceGroupName;
    }

    //Also checks the alternative workgroup
    return currResource.resourceTypes.includes(taskResourceGroupName);
}


//Checks if assign is possible
function isAssignPossible(resource, task, allowOtherTask, allowMultitasking) {

    //Different group
    if (!isAssignAllowed(task, resource, allowOtherTask)) {
        return false;
    }

    if (!resource.isActive) {
        return false;
    }

    if (resource.currentTask != null && !allowMultitasking) {
        return false;
    }

    if (task.currentResource != null) {
        return false;
    }

    return true;
}


module.exports = { assignAllResources,  isAssignPossible, isAssignAllowed, handleEvent }